import { css } from '@emotion/react';

export const lightboxOverlayStyles = css`
  light-box::part(overlay) {
    z-index: 1201;
  }
`;

export const lightboxSingleImageStyles = css`
  light-box progressive-img[slot="content"] {
    --img-width: 90vw;
    --img-max-height: 90vh;
    --img-object-fit: contain;
  }
  ${lightboxOverlayStyles}
`;

export const lightboxCarouselStyles = css`
  light-box [slot="content"] {
    padding: 0 68px;
    width: fit-content;
    justify-content: center;
  }

  light-box [slot="content"] [data-testid="navigate"] {
    width: 68px;
  }

  light-box [slot="content"] [data-testid="navigate"] svg {
    margin: 0 16px;
  }

  light-box [slot="content"] [data-testid="image"] {
    width: fit-content;
  }

  light-box [slot="content"] > :last-child {
    flex-basis: 100%;
  }

  light-box [slot="content"] progressive-img {
    max-width: calc(90vw - 136px);
    --img-width: calc(90vw - 136px);
    --img-max-height: calc(90vh - 34px);
    --img-object-fit: contain;
  }

  light-box [slot="content"] [data-testid="navigate-dot"] svg circle {
    fill: #e0e0e0;
  }
  ${lightboxOverlayStyles}
`;
